import React, { useEffect, useState } from 'react';
import BasicField from 'components/basic/BasicField';
import { roles } from 'cassandra-shared-js/roles';
import { LoadingButtonNoGrid } from 'components/basic/LoadingButton';
import axiosClient from 'http/axios-client';
import { Typography } from '@material-ui/core';
import DoctorSearchForm from 'components/basic/DoctorSearchForm';
import usePermissions from 'hooks/permissions-hooks';

const Invitation = ({ inv, refetch }) => {
  const [ firstName, setFirstName ] = useState('');
  const [ lastName, setLastName ] = useState('');
  const [ specialty, setSpecialty ] = useState('');
  const [ email, setEmail ] = useState('');
  const [ mobileNumber, setMobileNumber ] = useState('');
  const [ businessNumber, setBusinessNumber ] = useState('');
  const [ id, setId ] = useState(null);

  const [ docUpdateLoading, setDocUpdateLoading ] = useState(false);

  useEffect(() => {
    setFirstName(inv?.metadata?.firstName ?? '');
    setLastName(inv?.metadata?.lastName ?? '');
    setSpecialty(inv?.metadata?.specialty ?? '');
    setEmail(inv?.metadata?.email ?? '');
    setMobileNumber(inv?.metadata?.mobileNumber ?? '');
    setBusinessNumber(inv?.metadata?.businessNumber ?? '');
  }, [ inv ]);

  const updateDoctor = (doc) => {
    if (doc) {
      setId(doc.id);
      setFirstName(doc.name);
      setLastName(doc.family_name);
      setSpecialty(doc.specialty);
      setEmail(doc.email);
      setMobileNumber(doc.phone_number);
      setBusinessNumber(doc.business_number);
    } else {
      setId(null);

      setFirstName(inv?.metadata?.firstName ?? '');
      setLastName(inv?.metadata?.lastName ?? '');
      setSpecialty(inv?.metadata?.specialty ?? '');
      setEmail(inv?.metadata?.email ?? '');
      setMobileNumber(inv?.metadata?.mobileNumber ?? '');
      setBusinessNumber(inv?.metadata?.businessNumber ?? '');
    }
  };

  const { userHasRole } = usePermissions();

  return (
    <div key={ inv.id }>
      {
        'pgx-doctor-consent' !== inv.reason && (
          <Typography variant='h6'>
            Details of the doctor who has been sent an invitation
          </Typography>
        )
      }
      {
        'pgx-doctor-consent' === inv.reason && (
          <Typography variant='h6'>
            Details of the doctor who has been asked for consent for CNS PGx
          </Typography>
        )
      }

      {
        userHasRole(roles.ADMINISTRATOR_ROLE) && (
          <>
            <Typography
              variant='body1'
              style={ { width: '100%', fontWeight: 'bold' } }
            >
              Search for a doctor
            </Typography>

            <div style={ { display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '15px' } }
            >
              <DoctorSearchForm title='Search for a doctor' func={ updateDoctor } />
              <LoadingButtonNoGrid
                disabled={ null === id }
                variant='contained'
                loading={ docUpdateLoading }
                label='Save'
                color='primary'
                onClick={ () => {
                  setDocUpdateLoading(true);
                  axiosClient.put(`/invitations/admin-update/${ inv.id }`, {
                    new_doctor_id: id,
                  }).then(() => {
                    return refetch();
                  }).finally(() => {
                    setDocUpdateLoading(false);
                  });
                } }
              />
            </div>
          </>
        )
      }

      <BasicField
        title='First Name'
        field={ firstName }
        disabled
      />
      <BasicField
        title='Last Name'
        field={ lastName }
        disabled
      />
      <BasicField
        title='Specialty'
        field={ specialty }
        disabled
      />
      <BasicField
        title='Email'
        field={ email }
        disabled
      />
      <BasicField
        title='Mobile Number'
        field={ mobileNumber }
        disabled
      />
      <BasicField
        title='Business Number'
        field={ businessNumber }
        disabled
      />
    </div>
  );
};

export default Invitation;
